const SEASON_SIX_STORAGE_KEY = 'shem_season6_unlocked';
const DEFAULT_SEASON_SIX_CODE = 'SEASON6';

export const isSeasonSixResource = (resource = {}) => {
  const haystack = [
    resource.title,
    resource.module,
    resource.description,
    resource.intake,
    resource.season,
    resource.tag
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  return haystack.includes('season 6') || haystack.includes('season six');
};

export const getSeasonSixCode = () => process.env.REACT_APP_SEASON6_ACCESS_CODE || DEFAULT_SEASON_SIX_CODE;

export const hasSeasonSixCodeAccess = () => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(SEASON_SIX_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const grantSeasonSixCodeAccess = () => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(SEASON_SIX_STORAGE_KEY, 'true');
  } catch {
    // ignore storage failures
  }
};

export const clearSeasonSixCodeAccess = () => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(SEASON_SIX_STORAGE_KEY);
  } catch {
    // ignore storage failures
  }
};

export const hasSeasonSixAccess = (user) => {
  return Boolean(user?.lmsActive || user?.accessStatus === 'paid' || hasSeasonSixCodeAccess());
};

export const validateSeasonSixCode = (value) => {
  return String(value || '').trim().toUpperCase() === getSeasonSixCode().trim().toUpperCase();
};
